import { grayColor } from "../../cmsMainStyle";

const transAtthStyle = (theme) => ({
  textRoot: {
    "& .MuiTextField-root": {
      //   width: "100%",
      marginTop: theme.spacing(2),
    },
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  boxArea: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingLeft: theme.spacing(0.8),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1.5),
  },
  headerText: {
    fontStyle: "italic",
    fontWeight: "bold",
    color: "#181818",
    fontSize: "1.2rem",
  },
  subHeaderText: {
    fontStyle: "italic",
    fontWeight: "bold",
    color: "#606060",
  },
  searchBar: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: grayColor[1],

    "&:hover": {
      backgroundColor: grayColor[2],
    },

    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",

    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },

  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  inputRoot: {
    color: "inherit",
  },

  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "100ch",
    },
  },
  fileUploadBtnArea: {
    textAlign: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
});

export { transAtthStyle };
